<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M12,3C12,3,11,3,11,3C10.45,3,10,3.45,10,4C10,4,10,6.720000000000001,10,6.720000000000001C10,6.720000000000001,5.62,3.22,5.62,3.22C5.62,3.22,5.62,3.23,5.62,3.23C5.4399999999999995,3.09,5.24,3,5,3C4.45,3,4,3.45,4,4C4,4,4,12,4,12C4,12.55,4.45,13,5,13C5.24,13,5.4399999999999995,12.91,5.62,12.77C5.62,12.77,5.63,12.78,5.63,12.78C5.63,12.78,10,9.280000000000001,10,9.280000000000001C10,9.280000000000001,10,12,10,12C10,12.55,10.45,13,11,13C11,13,12,13,12,13C12.55,13,13,12.55,13,12C13,12,13,4,13,4C13,3.45,12.55,3,12,3C12,3,12,3,12,3Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'StepForward',
} as DefineComponent
</script>
